
let imageWithTextSliders = document.querySelectorAll('.js-image-with-text-slider');

if(imageWithTextSliders){
    imageWithTextSliders.forEach((slider) => {
        let autoplayDelay = slider.dataset.autoplayDelay,
            autoplaySettings = {
                delay: autoplayDelay
            };
        const swiper = new Swiper(slider, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: autoplaySettings,
            navigation: {
                nextEl: '.swiper-arrow-next',
                prevEl: '.swiper-arrow-prev',
                disabledClass: "swiper-arrow-disabled"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });
    });
}
let imageWithProducts = document.querySelectorAll('.js-image-with-products');
if(imageWithProducts){
    imageWithProducts.forEach(function (section){
        let hoverElements = section.querySelectorAll('[data-hover-element]');
        hoverElements.forEach(function (element){
            element.addEventListener('mouseenter',function (){
                let elementId = this.dataset.id;
                document.querySelectorAll(`[data-hover-element][data-id="${elementId}"]`).forEach(link=>{
                    link.classList.add('active')
                })
            })
        })
        hoverElements.forEach(function (element){
            element.addEventListener('mouseleave',function (){
                let elementId = this.dataset.id;
                document.querySelectorAll(`[data-hover-element][data-id="${elementId}"]`).forEach(link=>{
                    link.classList.remove('active')
                })
            })
        })
    })
}